<template>
  <v-card>
    <v-tabs v-model="tab" background-color="primary" grow dark>
      <v-tabs-slider></v-tabs-slider>
      <v-tab to="/w_h/stocks"><v-icon color="white" class="mr-1">mdi-store</v-icon> {{ $t('message.warehouse.stock') }}</v-tab>
      <v-tab to="/w_h/order"><v-icon color="white" class="mr-1">mdi-cart-plus</v-icon> {{ $t('message.warehouse.order') }}</v-tab>
      <v-tab to="/w_h/ccsheet"><v-icon color="white" class="mr-1">mdi-format-list-checks</v-icon> {{ $t('message.warehouse.ccsheet') }}</v-tab>
      <v-tab to="/w_h/products"><v-icon color="white" class="mr-1">mdi-semantic-web</v-icon> {{ $t('message.warehouse.product') }}</v-tab>
    </v-tabs>
   <router-view></router-view>
  </v-card>
</template>
<script>
export default {
  data () {
    return {
      tab: null
    }
  },
  watch: {
    '$route.name' (val) {
      if (!val) this.$router.go(-1)
    }
  },
  mounted () {
    if (!this.$route.name) this.$router.push('/w_h/stocks')
  }
}
</script>
